import { termGroups } from '@/components/estimating/agreements/preview/InvestmentPage';
import { usd } from '@/components/estimating/agreements/agreementFormat';

const OVERLINE = 'text-[10px] font-semibold uppercase tracking-[0.16em] text-[#5C6370]';

// How the client pays for what's on the page now: the main payments, then each service that pays on its own schedule.
export default function ProposalTerms({ terms, quoting, color, hfont }) {
  const groups = termGroups(terms || {});
  if (!groups.length) return null;
  let n = 0;
  return (
    <section className={`mt-8 space-y-2 transition-opacity ${quoting ? 'opacity-60' : ''}`} data-testid="proposal-public-terms" aria-live="polite">
      <p className={OVERLINE}>Payment terms</p>
      {groups.map((g, gi) => (
        <div key={g.key} className="overflow-hidden rounded-md border border-[#D5D8DD]" data-testid={`proposal-terms-group-${gi}`}>
          {g.name && (
            <p className="flex items-baseline justify-between gap-3 border-b-2 bg-[#F7F8FA] px-4 py-2 font-exo text-sm font-bold text-[#0D1B2A]" style={{ borderColor: color, ...hfont }}
              data-testid={`proposal-terms-group-${gi}-name`}>
              <span>{g.name}</span><span className="tabular-nums">{usd(g.cents)}</span>
            </p>
          )}
          <ul className="divide-y divide-[#EEF0F2]">
            {g.terms.map((t) => {
              const i = n++;
              return (
                <li key={i} className="flex items-baseline justify-between gap-4 px-4 py-2.5" data-testid={`proposal-term-${i}`}>
                  <span className="min-w-0 text-[13px] text-[#0D1B2A]"><span className="font-semibold">{t.name}</span>
                    <span className="block text-[11px] text-[#5C6370]">{[t.share, t.trigger].filter(Boolean).join(' · ')}</span></span>
                  <span className="shrink-0 font-exo text-[13px] font-semibold tabular-nums text-[#0D1B2A]" data-testid={`proposal-term-${i}-amount`}>{usd(t.amount_cents)}</span>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </section>
  );
}
